module.exports = __webpack_public_path__ + "static/media/logo_customerexpert.79934fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerexpert/logo_customerexpert.png
// module id = 1621
// module chunks = 0